<template>
  <div>
    <highcharts ref="chart" :options="options" />
    <br />
    <b-table
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="values"
      :columns="columns"
    />
  </div>
</template>

<script>
import Commute from '@/models/carbon/Commute.js'
import '@/plugins/highcharts.js'

export default {
  name: 'CommutesEmissionsBar',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    values: function () {
      let values = []
      let intensities = this.ghgi.emissions.commutes.status.intensity
      for (let position of Object.keys(intensities)) {
        let allModes = {}
        let i = 0
        for (let mode of Commute.TRAVELS_MODES) {
          allModes[mode] =
            '<nobr>' +
            this.$options.filters.splitNumberTons(
              intensities[position][i].intensity
            )
          allModes[mode] +=
            ' +/- ' +
            this.$options.filters.splitNumberTons(
              intensities[position][i].uncertainty
            ) +
            '</nobr>'
          i += 1
        }
        allModes['position'] = '<nobr>' + this.$t(position) + '</nobr>'
        values.push(allModes)
      }
      return values
    },
    columns: function () {
      let columns = [
        {
          field: 'position',
          label: this.$t('position'),
          sticky: true
        }
      ]
      for (let mode of Commute.TRAVELS_MODES) {
        columns.push({
          field: mode,
          label: this.$t(mode),
          numeric: true
        })
      }
      return columns
    },
    series: function () {
      let intensities = this.ghgi.emissions.commutes.status.intensity
      let sz = []
      for (let position of Object.keys(intensities)) {
        sz.push({
          name: this.$t(position + '.short'),
          data: this.ghgi.emissions.commutes.status.intensity[position].map(
            (obj) => obj.intensity / 1000
          )
        })
      }
      return sz
    },
    options: function () {
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        series: this.series,
        xAxis: {
          categories: Commute.TRAVELS_MODES.map((val) => this.$t(val)),
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('emissions.t.co2e.short')
          }
        },
        tooltip: {
          shared: true,
          valueDecimals: 2,
          valueSuffix: ' ' + this.$t('t.co2e')
        }
      }
    }
  }
}
</script>
